/**
 * R24 · „Was suchen Sie?“ — smarte Suche + Leben (Owner 02.11.2026, Runde 3).
 * Gehört zu sections/r24-quickbar-2026.liquid, `defer`, kein Liquid in dieser Datei.
 *
 * 1 · Vorschläge beim Tippen: EIN Abruf /search/suggest.json (Suchbegriffe, Kategorien, Seiten, Produkte
 *     mit Bild und Preis), 180 ms Pause, alter Abruf wird abgebrochen, Antworten je Begriff gemerkt.
 *     Leeres Feld mit Fokus: Zuletzt gesucht (r24_recent_q, wie die Kopf-Suche), Bereiche (= Kacheln der
 *     Sektion), Gerade gefragt (Kollektion der Nacht-Routine, Daten im JSON-Block der Sektion).
 *     SICHERHEIT wie r24-header-search.js: fremder Text NUR per textContent, jede URL durch safeUrl().
 *     Tastatur: ↑/↓ wählt, Enter öffnet, Esc schließt. Artikelnummer mit genau einem Treffer → direkt zum Produkt.
 * 2 · Leben: Beispiele tippen sich ins leere Feld, „Gerade gefragt“ wechselt alle 4,5 s, Zahlen zählen hoch,
 *     Kacheln blenden gestaffelt ein (nur was beim Laden unter der Falz liegt). Alles nur sichtbar,
 *     nie bei prefers-reduced-motion, Pause bei Zeigen/Fokus/verdecktem Tab.
 * Abrufregel: nie werfen, JSON nur wenn der Body JSON ist, 20 s Zeitlimit, console.warn statt stillem catch.
 */
(function () {
  'use strict';
  var REDUCED = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var HAS_IO = typeof window.IntersectionObserver === 'function';
  var RECENT_KEY = 'r24_recent_q', RECENT_TS = 'r24_recent_q_ts', RECENT_TTL = 30 * 864e5;

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function safeUrl(u) {
    if (!u) return '';
    try { var x = new URL(String(u), location.origin); return (x.protocol === 'http:' || x.protocol === 'https:') ? x.href : ''; }
    catch (e) { return ''; }
  }
  function img(u, w) {
    var s = safeUrl(u); if (!s) return '';
    try { var x = new URL(s); x.searchParams.set('width', String(w)); return x.href; } catch (e) { return s; }
  }
  /* gleiche Länge wie der Text (ß → s), damit die Markierung an der richtigen Stelle sitzt */
  function normL(t) { return String(t || '').toLowerCase().replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 's'); }
  function isCode(q) { return /\d/.test(q) && /^\S+$/.test(q) && q.length >= 4; }
  var EUR = null;
  function money(v) {
    var n = parseFloat(v); if (!isFinite(n)) return '';
    try {
      if (!EUR) EUR = new Intl.NumberFormat('de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
      return EUR.format(n);
    } catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
  }
  function recentRead() {
    try {
      var t = +localStorage.getItem(RECENT_TS) || 0; if (t && Date.now() - t > RECENT_TTL) return [];
      var l = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(l) ? l.filter(function (s) { return typeof s === 'string' && s.trim().length > 1; }).slice(0, 5) : [];
    } catch (e) { console.warn('[R24 Schnellsuche] Suchverlauf nicht lesbar:', e && e.message); return []; }
  }
  function recentWrite(list) {
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 5))); localStorage.setItem(RECENT_TS, String(Date.now())); }
    catch (e) { console.warn('[R24 Schnellsuche] Suchverlauf nicht speicherbar:', e && e.message); }
  }
  function remember(q) {
    q = String(q || '').replace(/\s+/g, ' ').trim().slice(0, 80); if (q.length < 2) return;
    recentWrite([q].concat(recentRead().filter(function (s) { return s.toLowerCase() !== q.toLowerCase(); })));
  }
  /* Abruf nach Hausregel (wie r24Fetch, eigener Name — die r24Fetch-Kopien hält ein Test gleich). */
  function qbFetch(url, signal) {
    var ctl = typeof AbortController === 'function' ? new AbortController() : null, tm = 0;
    if (signal && ctl) signal.addEventListener('abort', function () { ctl.abort(); });
    if (ctl) tm = setTimeout(function () { ctl.abort(); }, 20000);
    return fetch(url, { signal: ctl ? ctl.signal : undefined, credentials: 'same-origin' }).then(function (r) {
      return r.text().then(function (t) {
        clearTimeout(tm);
        var d = null;
        if (/^\s*[\[{]/.test(t || '')) { try { d = JSON.parse(t); } catch (e) { d = null; } }
        return { ok: r.ok && !!d, status: r.status, data: d };
      });
    }).then(null, function (e) {
      clearTimeout(tm);
      var ab = !!(e && e.name === 'AbortError');
      if (!ab) console.warn('[R24 Schnellsuche] ' + url + ': ' + ((e && e.message) || e));
      return { ok: false, status: 0, data: null, aborted: ab };
    });
  }
  var ICON = {
    q: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm9.3 16.3-4-4',
    r: 'M4 12a8 8 0 1 0 2.3-5.7M4 4v4h4',
    c: 'M3 7h7l2 2h9v10H3z',
    p: 'M6 3h9l4 4v14H6zM14 3v5h5'
  };
  function icon(k) {
    var ns = 'http://www.w3.org/2000/svg', sv = document.createElementNS(ns, 'svg'), pa = document.createElementNS(ns, 'path');
    sv.setAttribute('viewBox', '0 0 24 24'); sv.setAttribute('width', '16'); sv.setAttribute('height', '16'); sv.setAttribute('aria-hidden', 'true');
    sv.setAttribute('fill', 'none'); sv.setAttribute('stroke', 'currentColor'); sv.setAttribute('stroke-width', '2'); sv.setAttribute('stroke-linecap', 'round'); sv.setAttribute('stroke-linejoin', 'round');
    pa.setAttribute('d', ICON[k] || ICON.q); sv.appendChild(pa);
    var w = el('span', 'r24qb-sd__ico'); w.appendChild(sv); return w;
  }
  /* Treffer fett: Text in Stücke, nur textContent. */
  function hl(node, text, q) {
    var t = String(text || ''), nt = normL(t), words = normL(q).split(/\s+/).filter(function (w) { return w.length > 1; });
    var marks = new Array(t.length + 1).join('0').split('');
    words.forEach(function (w) { var i = nt.indexOf(w); while (i > -1) { for (var k = i; k < i + w.length; k++) marks[k] = '1'; i = nt.indexOf(w, i + w.length); } });
    var cur = null, buf = '';
    function flush() { if (!buf) return; if (cur === '1') { var m = el('mark', null, buf); node.appendChild(m); } else node.appendChild(document.createTextNode(buf)); buf = ''; }
    for (var i = 0; i < t.length; i++) { if (marks[i] !== cur) { flush(); cur = marks[i]; } buf += t[i]; }
    flush();
  }

  /* Wiederkehrende Planer (Phase 4, 02.11.2026): liegt eine gespeicherte Küchenplanung auf diesem Gerät
     (royal_kp_last, vom Küchenplaner beim Verlassen gesichert), heißt die Planer-Kachel „Planung fortsetzen“.
     Der Planer öffnet die letzte Planung selbst („Willkommen zurück“) — hier ändert sich nur die Beschriftung. */
  function resumePlan(root) {
    var card = root.querySelector('.r24qb__card--accent[href*="kuechenplaner"]');
    if (!card) return;
    var plan = null;
    try { plan = JSON.parse(localStorage.getItem('royal_kp_last') || 'null'); } catch (e) { plan = null; }
    if (!plan || typeof plan !== 'object') return;
    var t = card.querySelector('.r24qb__t'), n = card.querySelector('.r24qb__n'), b = card.querySelector('.r24qb__badge');
    if (t) t.textContent = 'Planung fortsetzen';
    if (n) n.textContent = 'Ihre Küche ist auf diesem Gerät gespeichert';
    if (b && b.lastChild && b.lastChild.nodeType === 3) b.lastChild.nodeValue = ' Weiter, wo Sie aufgehört haben';
    card.setAttribute('data-r24qb-resume', '1');
  }

  function initSection(root) {
    if (root.__r24qb) return; root.__r24qb = 1;
    resumePlan(root);
    var form = root.querySelector('[data-r24qb-form]');
    var input = form && form.querySelector('input[name="q"]');
    var sd = root.querySelector('[data-r24qb-sd]');
    var live = [];
    try { var ld = root.querySelector('[data-r24qb-livedata]'); if (ld) live = JSON.parse(ld.textContent || '[]') || []; }
    catch (e) { console.warn('[R24 Schnellsuche] Gerade-gefragt-Daten unlesbar:', e && e.message); }
    var areas = Array.prototype.map.call(root.querySelectorAll('[data-r24qb-grid] .r24qb__card'), function (a) {
      var t = a.querySelector('.r24qb__t'), n = a.querySelector('.r24qb__n'), im = a.querySelector('img');
      return { t: t ? t.textContent.trim() : '', n: n ? n.textContent.replace(/\s+/g, ' ').trim() : '', u: a.getAttribute('href'), i: im ? (im.currentSrc || im.src) : '' };
    });

    lively(root, input);
    if (!form || !input || !sd) return;

    var clearBtn = form.querySelector('[data-r24qb-clear]');
    var opts = [], act = -1, timer = 0, ctrl = null, cache = {}, lastQ = null, single = '';

    function setOpen(on) {
      var was = !sd.hidden;
      sd.hidden = !on; input.setAttribute('aria-expanded', on ? 'true' : 'false');
      root.classList.toggle('is-sd', on);
      if (on) { fit(); if (!was) center(); }
      else { act = -1; input.removeAttribute('aria-activedescendant'); }
    }
    /* Ausrichtung (Owner 02.11.2026: „Seite und Suchfenster beim Klick automatisch ausrichten, nichts abschneiden“):
       1 · Feld rückt sanft direkt unter den (klebenden) Kopf, damit die Vorschläge den größten Platz haben.
       2 · Fensterhöhe = sichtbarer Platz unter dem Feld (auch mit Handy-Tastatur, visualViewport) — innen scrollt es.
       3 · Rechner: das Fenster wird breiter (bis 920 px) und wächst nach links über die Kacheln, bleibt in der Glasfläche. */
    var wrap = root.querySelector('[data-r24qb-wrap]'), panel = root.querySelector('.r24qb__panel'), fitRaf = 0, centered = 0;
    function headBottom() {
      var b = 0, x = Math.round((window.innerWidth || 800) / 2);
      [4, 40].forEach(function (y) {
        var n = document.elementFromPoint(x, y);
        while (n && n !== document.body && n !== document.documentElement) {
          var cs = getComputedStyle(n);
          if (cs.position === 'fixed' || cs.position === 'sticky') { var r = n.getBoundingClientRect(); if (r.top <= 1 && r.bottom > b && r.bottom < (window.innerHeight || 800) * 0.4) b = r.bottom; break; }
          n = n.parentElement;
        }
      });
      return b;
    }
    function viewH() { return (window.visualViewport && window.visualViewport.height) || window.innerHeight || 800; }
    function fit() {
      if (sd.hidden || !wrap) return;
      var fr = form.getBoundingClientRect(), wr = wrap.getBoundingClientRect();
      var avail = Math.floor(viewH() - fr.bottom - 8 - 16);
      sd.style.maxHeight = Math.max(240, Math.min(640, avail)) + 'px';
      if (panel && (window.innerWidth || 0) >= 990) {
        var pr = panel.getBoundingClientRect(), pad = 24;
        var left = Math.max(pr.left + pad, wr.right - 920);
        sd.style.left = Math.min(0, Math.round(left - wr.left)) + 'px';
      } else sd.style.left = '';
    }
    function center() {
      var now = Date.now(); if (now - centered < 800) return; centered = now;
      var fr = form.getBoundingClientRect(), want = headBottom() + 16, d = Math.round(fr.top - want);
      /* nur verschieben, wenn darunter zu wenig Platz ist oder das Feld halb verdeckt — kein Springen bei genug Raum */
      var below = viewH() - fr.bottom;
      if (Math.abs(d) < 12 || (d > 0 && below > 520 && fr.top >= want)) { fit(); return; }
      try { window.scrollBy({ top: d, behavior: REDUCED ? 'auto' : 'smooth' }); } catch (e) { window.scrollBy(0, d); }
    }
    function refit() { if (fitRaf) return; fitRaf = requestAnimationFrame(function () { fitRaf = 0; fit(); }); }
    window.addEventListener('scroll', refit, { passive: true });
    window.addEventListener('resize', refit);
    if (window.visualViewport) { window.visualViewport.addEventListener('resize', refit); window.visualViewport.addEventListener('scroll', refit); }
    function setAct(i) {
      if (!opts.length) return;
      if (act > -1 && opts[act]) opts[act].classList.remove('is-act');
      act = (i + opts.length) % opts.length;
      var o = opts[act]; o.classList.add('is-act'); input.setAttribute('aria-activedescendant', o.id);
      if (o.scrollIntoView) o.scrollIntoView({ block: 'nearest' });
    }
    var oid = 0;
    function opt(href, cls) {
      var a = el('a', 'r24qb-sd__opt' + (cls ? ' ' + cls : '')); a.href = safeUrl(href) || '#';
      a.id = root.id + '-o' + (++oid); a.setAttribute('role', 'option'); a.tabIndex = -1;
      opts.push(a); return a;
    }
    function group(col, title, extra) {
      var h = el('div', 'r24qb-sd__h'); h.appendChild(el('span', null, title)); if (extra) h.appendChild(extra);
      col.appendChild(h); var g = el('div', 'r24qb-sd__g'); g.setAttribute('role', 'group'); g.setAttribute('aria-label', title); col.appendChild(g); return g;
    }
    function product(g, p, q) {
      var a = opt(p.url, 'r24qb-sd__p');
      var src = img(p.image || (p.featured_image && p.featured_image.url), 160);
      if (src) { var im = el('img', 'r24qb-sd__pimg'); im.src = src; im.alt = ''; im.loading = 'lazy'; im.width = 60; im.height = 60; a.appendChild(im); }
      var t = el('span', 'r24qb-sd__pt'), nm = el('span', 'r24qb-sd__pn'); hl(nm, p.title, q || ''); t.appendChild(nm);
      var pr = el('span', 'r24qb-sd__pp', p.price != null ? (String(p.price).indexOf('€') > -1 ? String(p.price) : money(p.price)) : '');
      var cmp = parseFloat(p.compare_at_price_max), pv = parseFloat(p.price);
      if (isFinite(cmp) && isFinite(pv) && cmp > pv) pr.appendChild(el('s', null, money(cmp)));
      if (p.available === false) pr.appendChild(el('span', 'r24qb-sd__na', ' · derzeit nicht lieferbar'));
      if (pr.textContent) t.appendChild(pr);
      a.appendChild(t); g.appendChild(a);
    }
    function foot(q) {
      var f = el('div', 'r24qb-sd__foot');
      var k = el('span', 'r24qb-sd__kbd');
      k.appendChild(el('kbd', null, '↑')); k.appendChild(el('kbd', null, '↓')); k.appendChild(document.createTextNode(' wählen  ')); k.appendChild(el('kbd', null, 'Enter')); k.appendChild(document.createTextNode(' öffnen'));
      f.appendChild(k);
      if (q) {
        var all = opt(searchUrl(q), 'r24qb-sd__all'); all.className = 'r24qb-sd__all';
        all.textContent = 'Alle Ergebnisse für „' + q + '“ →'; f.appendChild(all);
      }
      return f;
    }
    function searchUrl(q) { return (form.getAttribute('action') || '/search') + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; }
    function reset() { sd.textContent = ''; opts = []; act = -1; oid = 0; }

    function renderEmpty() {
      reset(); single = '';
      var grid = el('div', 'r24qb-sd__grid'), c1 = el('div', 'r24qb-sd__col'), c2 = el('div', 'r24qb-sd__col');
      var rec = recentRead();
      if (rec.length) {
        var clr = el('button', 'r24qb-sd__clr', 'Verlauf löschen'); clr.type = 'button';
        clr.addEventListener('mousedown', function (e) { e.preventDefault(); });
        clr.addEventListener('click', function () { recentWrite([]); renderEmpty(); input.focus(); });
        var g = group(c1, 'Zuletzt gesucht', clr);
        rec.forEach(function (q) { var a = opt(searchUrl(q)); a.appendChild(icon('r')); a.appendChild(el('span', null, q)); g.appendChild(a); });
      }
      /* Phase 3: echte häufige Suchbegriffe (Shop-Metafeld r24.beliebte_suchen, Nacht-Routine). */
      var pop = (input.getAttribute('data-r24qb-pop') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean)
        .filter(function (q) { return rec.map(function (r) { return r.toLowerCase(); }).indexOf(q.toLowerCase()) < 0; }).slice(0, 5);
      if (pop.length) {
        var gq = group(c1, 'Oft gesucht');
        pop.forEach(function (q) { var a = opt(searchUrl(q)); a.appendChild(icon('q')); a.appendChild(el('span', null, q.split(' ').map(function (w) { return w === 'cm' ? w : w.charAt(0).toUpperCase() + w.slice(1); }).join(' '))); gq.appendChild(a); });
      }
      if (areas.length) {
        var ga = group(c1, 'Bereiche');
        areas.forEach(function (x) {
          var a = opt(x.u);
          if (x.i) { var im = el('img', 'r24qb-sd__cimg'); im.src = img(x.i, 120) || x.i; im.alt = ''; im.width = 40; im.height = 40; a.appendChild(im); } else a.appendChild(icon('c'));
          var s = el('span', 'r24qb-sd__pt'); s.appendChild(el('span', null, x.t)); if (x.n) s.appendChild(el('span', 'r24qb-sd__na', x.n)); a.appendChild(s); ga.appendChild(a);
        });
      }
      if (live.length) {
        var gp = group(c2, 'Gerade gefragt');
        live.slice(0, 5).forEach(function (p) { product(gp, { url: p.u, title: p.t, image: p.i, price: p.p, available: p.a }, ''); });
      } else c2.appendChild(el('div', 'r24qb-sd__msg', 'Tippen Sie z. B. eine Breite, Farbe oder Serie — die Vorschläge erscheinen sofort.'));
      grid.appendChild(c1); grid.appendChild(c2); sd.appendChild(grid); sd.appendChild(foot(''));
      setOpen(true);
    }
    function renderLoading(q) {
      reset();
      var grid = el('div', 'r24qb-sd__grid'), c1 = el('div', 'r24qb-sd__col'), c2 = el('div', 'r24qb-sd__col');
      c1.appendChild(el('div', 'r24qb-sd__h', 'Vorschläge'));
      for (var i = 0; i < 3; i++) { var s = el('div', 'r24qb-sd__skel'); s.style.height = '36px'; c1.appendChild(s); }
      c2.appendChild(el('div', 'r24qb-sd__h', 'Produkte'));
      for (var j = 0; j < 3; j++) c2.appendChild(el('div', 'r24qb-sd__skel'));
      grid.appendChild(c1); grid.appendChild(c2); sd.appendChild(grid); sd.appendChild(foot(q));
      setOpen(true);
    }
    function renderResults(q, res) {
      reset();
      var r = (res && res.resources && res.resources.results) || {};
      var qs = (r.queries || []).slice(0, 5), cs = (r.collections || []).slice(0, 4), ps = (r.pages || []).slice(0, 3), pr = (r.products || []).slice(0, 6);
      single = (isCode(q) && pr.length === 1) ? safeUrl(pr[0].url) : '';
      if (!qs.length && !cs.length && !ps.length && !pr.length) {
        var m = el('div', 'r24qb-sd__msg');
        m.appendChild(document.createTextNode('Keine direkten Vorschläge für „' + q + '“. Mit Enter durchsuchen wir alle Artikel — oder versuchen Sie ein anderes Wort, z. B. die Serie oder die Breite.'));
        sd.appendChild(m); sd.appendChild(foot(q)); setOpen(true); return;
      }
      var grid = el('div', 'r24qb-sd__grid'), c1 = el('div', 'r24qb-sd__col'), c2 = el('div', 'r24qb-sd__col');
      if (qs.length) {
        var g = group(c1, 'Vorschläge');
        qs.forEach(function (x) { var a = opt(searchUrl(x.text)); a.appendChild(icon('q')); var s = el('span'); hl(s, x.text, q); a.appendChild(s); g.appendChild(a); });
      }
      if (cs.length) {
        var gc = group(c1, 'Kategorien');
        cs.forEach(function (x) {
          var a = opt(x.url), fi = x.featured_image && (x.featured_image.url || x.featured_image);
          if (fi && typeof fi === 'string') { var im = el('img', 'r24qb-sd__cimg'); im.src = img(fi, 120); im.alt = ''; im.width = 40; im.height = 40; a.appendChild(im); } else a.appendChild(icon('c'));
          var s = el('span'); hl(s, x.title, q); a.appendChild(s); gc.appendChild(a);
        });
      }
      if (ps.length) {
        var gs = group(c1, 'Seiten & Ratgeber');
        ps.forEach(function (x) { var a = opt(x.url); a.appendChild(icon('p')); var s = el('span'); hl(s, x.title, q); a.appendChild(s); gs.appendChild(a); });
      }
      if (pr.length) { var gp = group(c2, 'Produkte'); pr.forEach(function (p) { product(gp, p, q); }); }
      /* Nur eine Art Treffer: eine Spalte (Produkte dann zweispaltig), keine leere Hälfte. */
      if (!c1.childNodes.length || !pr.length) {
        grid.className = 'r24qb-sd__grid r24qb-sd__grid--one';
        grid.appendChild(c1.childNodes.length ? c1 : c2);
      } else { grid.appendChild(c1); grid.appendChild(c2); }
      sd.appendChild(grid); sd.appendChild(foot(q));
      setOpen(true);
    }
    function url(q) {
      return '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=query,collection,page,product&resources[limit]=6&resources[limit_scope]=each'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,product_type,variants.title,variants.sku';
    }
    function run() {
      var q = input.value.replace(/\s+/g, ' ').trim();
      if (clearBtn) clearBtn.hidden = !input.value;
      if (q === lastQ && !sd.hidden) return;
      lastQ = q;
      if (q.length < 2) { renderEmpty(); return; }
      if (cache[q]) { renderResults(q, cache[q]); return; }
      renderLoading(q);
      if (ctrl) ctrl.abort();
      ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      qbFetch(url(q), ctrl && ctrl.signal).then(function (r) {
        if (r.aborted || q !== input.value.replace(/\s+/g, ' ').trim()) return;
        if (!r.ok) {
          reset();
          var m = el('div', 'r24qb-sd__msg', r.status === 429 ? 'Gerade sehr viele Anfragen — Enter sucht trotzdem in allen Artikeln.' : 'Vorschläge sind gerade nicht erreichbar. Mit Enter suchen Sie in allen Artikeln.');
          sd.appendChild(m); sd.appendChild(foot(q)); setOpen(true); return;
        }
        cache[q] = r.data; renderResults(q, r.data);
      });
    }

    input.addEventListener('focus', function () { lastQ = null; run(); });
    input.addEventListener('input', function () { clearTimeout(timer); if (clearBtn) clearBtn.hidden = !input.value; timer = setTimeout(run, 180); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (sd.hidden) run(); else setAct(act + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setAct(act - 1); }
      else if (e.key === 'Escape') { if (!sd.hidden) { e.preventDefault(); setOpen(false); } }
      else if (e.key === 'Enter' && act > -1 && opts[act]) {
        e.preventDefault(); var q = input.value.trim(); if (q) remember(q); location.href = opts[act].href;
      }
    });
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; clearBtn.hidden = true; lastQ = null; input.focus(); run(); });
    sd.addEventListener('mousedown', function (e) { if (e.target.closest && e.target.closest('a')) { var q = input.value.trim(); if (q) remember(q); } });
    document.addEventListener('pointerdown', function (e) { if (!sd.hidden && !root.querySelector('[data-r24qb-wrap]').contains(e.target)) setOpen(false); });
    input.addEventListener('blur', function () { setTimeout(function () { if (!root.querySelector('[data-r24qb-wrap]').contains(document.activeElement)) setOpen(false); }, 150); });
    form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); input.focus(); return; }
      remember(q);
      if (single) { e.preventDefault(); location.href = single; }
    });

    /* Zuletzt gesucht als Chips unter dem Feld */
    var rec = recentRead(), chips = root.querySelector('[data-r24qb-chips]');
    if (rec.length && chips) {
      var lab = chips.querySelector('[data-r24qb-chl]'); if (lab) lab.textContent = 'Zuletzt gesucht';
      Array.prototype.forEach.call(chips.querySelectorAll('.r24qb__chip'), function (a) { a.remove(); });
      rec.slice(0, 4).forEach(function (q) { var a = el('a', 'r24qb__chip r24qb__chip--recent', q); a.href = searchUrl(q); chips.appendChild(a); });
    }
  }

  /* ---------------------------------------------------------------- 2 · Leben */
  function lively(root, input) {
    var vis = false;
    function onVis(fn) { if (!HAS_IO) { fn(true); return; } new IntersectionObserver(function (es) { es.forEach(function (e) { fn(e.isIntersecting); }); }, { threshold: 0.15 }).observe(root); }

    /* Kacheln gestaffelt — nur, wenn die Sektion beim Laden unter der Falz liegt (nie Sichtbares verstecken). */
    var below = root.getBoundingClientRect().top > (window.innerHeight || 800) * 0.85;
    if (!REDUCED && HAS_IO && below) root.classList.add('qb-anim');

    /* Zahlen zählen hoch, einmal. */
    var counted = false;
    function countUp() {
      if (counted || REDUCED) return; counted = true;
      Array.prototype.forEach.call(root.querySelectorAll('[data-r24qb-count]'), function (n) {
        var to = parseInt(n.getAttribute('data-r24qb-count'), 10); if (!(to > 0)) return;
        var t0 = 0, dur = 900 + Math.min(600, to);
        function step(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / dur); n.textContent = String(Math.round(to * (1 - Math.pow(1 - k, 3)))); if (k < 1) requestAnimationFrame(step); }
        n.textContent = '0'; requestAnimationFrame(step);
      });
    }

    /* Phase 3: „· vor N Tagen“ aus dem Bestelldatum (im Browser gerechnet, HTML darf zwischengespeichert sein). */
    Array.prototype.forEach.call(root.querySelectorAll('[data-r24qb-ago]'), function (n) {
      var d = new Date(n.getAttribute('datetime') + 'T12:00:00'); if (isNaN(d)) return;
      var days = Math.round((Date.now() - d.getTime()) / 864e5);
      n.textContent = '· ' + (days <= 0 ? 'heute' : days === 1 ? 'gestern' : 'vor ' + days + ' Tagen');
    });

    /* Gerade gefragt / Kürzlich bestellt: alle 4,5 s der nächste Titel. */
    var box = root.querySelector('[data-r24qb-live]'), items = box ? box.querySelectorAll('.r24qb__livea') : [], li = 0, paused = false;
    function tick() {
      if (!vis || paused || items.length < 2 || document.hidden) return;
      var cur = items[li], nx = items[(li + 1) % items.length];
      cur.classList.remove('is-on'); cur.classList.add('is-out'); cur.setAttribute('tabindex', '-1'); cur.setAttribute('aria-hidden', 'true');
      nx.classList.remove('is-out'); nx.classList.add('is-on'); nx.removeAttribute('tabindex'); nx.removeAttribute('aria-hidden');
      setTimeout(function () { cur.classList.remove('is-out'); }, 500);
      li = (li + 1) % items.length;
    }
    if (box) {
      box.addEventListener('mouseenter', function () { paused = true; });
      box.addEventListener('mouseleave', function () { paused = false; });
      box.addEventListener('focusin', function () { paused = true; });
      box.addEventListener('focusout', function () { paused = false; });
    }

    /* Beispiele tippen sich ins leere Feld. */
    var ex = input ? (input.getAttribute('data-r24qb-ex') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean) : [];
    /* Handy: kurzer Hinweis, der ins schmale Feld passt (der lange wird sonst abgeschnitten). */
    if (input && window.matchMedia && matchMedia('(max-width: 749px)').matches) input.setAttribute('placeholder', 'Küche, Schrank, Farbe …');
    var base = input ? input.getAttribute('placeholder') : '', ei = 0, ec = 0, dir = 1, tt = 0;
    function type() {
      clearTimeout(tt); if (!vis || !input) return;
      if (document.activeElement === input || input.value) { input.setAttribute('placeholder', base); tt = setTimeout(type, 1200); return; }
      var w = ex[ei]; ec += dir;
      input.setAttribute('placeholder', 'z. B. „' + w.slice(0, ec) + (dir > 0 && ec < w.length ? '▍' : '') + '“');
      var wait = dir > 0 ? 55 : 28;
      if (dir > 0 && ec >= w.length) { dir = -1; wait = 1700; }
      else if (dir < 0 && ec <= 0) { dir = 1; ei = (ei + 1) % ex.length; wait = 380; }
      tt = setTimeout(type, wait);
    }

    var iv = 0;
    onVis(function (on) {
      vis = on;
      if (on) {
        root.classList.add('is-in'); countUp();
        if (!REDUCED) { if (!iv && items.length > 1) iv = setInterval(tick, 4500); if (ex.length) { clearTimeout(tt); tt = setTimeout(type, 900); } }
      } else {
        if (iv) { clearInterval(iv); iv = 0; }
        clearTimeout(tt); if (input) input.setAttribute('placeholder', base);
      }
    });
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-r24qb]'), initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
